import BaseService from '@/services/base.service';
import { deleteToken, setToken } from '@/services/axios';

const API_URL = process.env.VUE_APP_API_URL;

class AuthService extends BaseService {
  loginPos(phone: string) {
    return this.post(API_URL+'/pos/api/login', { phone })
        .then((response) => {
          const status = response.data.status;
          if (status === 'success') {
            setToken(response.data.data);
          }

          return response.data;
        });
  }

  login(phone: string, password: string) {
    return this.post(API_URL+'/session/api/login', { phone, password })
      .then((response) => {
        const status = response.data.status;
        if (status === 'success') {
          setToken(response.data.data);
        }

        return response.data;
      });
  }

  getUser() {
    return this.get(API_URL+'/session/api/user').then(({ data }) => data);
  }

  register(fullName: string, phone: string, password: string) {
    return this.post(API_URL+'/session/api/register', {
      /* eslint-disable @typescript-eslint/camelcase */
      full_name: fullName,
      phone,
      password
    }).then((response) => {

      const status = response.data.status;
      if (status === 'success') {
        setToken(response.data.data);
      }

      return response.data;
    });
  }

  forgotPassword(phone: string) {
    return this.post(API_URL+'/session/api/forgotPassword', { phone })
        .then((response) => {
          return response.data;
        });
  }

  logout() {
    deleteToken();
    // return this.post(API_URL+'/session/api/logout', {}).then(() => deleteToken());
  }
}

export default new AuthService();